import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCarousel, { EcoSectionCarouselItemProps } from 'eco-design/sections/eco-section-carousel';
import { useProductStore } from '../../../../ProductProvider';
import { getImgUrl } from '../../utils';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

export default function Comp() {
    const { t } = useLang('theProduct.ListA1');
    const { t: s } = useLang('theProduct');
    const { pageStatus } = useProductStore();
    const { locale = 'us' } = getLocal();
    const IS_EU_SITE = ['eu', 'uk', 'fr', 'de', 'it', 'es'].includes(locale);
    const IS_JP_SITE = ['jp'].includes(locale);
    const item3Img = {
        jp: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745225463750/3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745225463750/3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745225461759/3-h5.jpg',
        },
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744340440092/4.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744340440092/4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744340440303/4-h5.jpg',
        },
        ca: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744355045108/4-ss.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744355045108/4-ss.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744700915836/4-ss.jpg',
        },
        eu: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745718687938/app-uk.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745718687938/app-uk.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745719262201/l-uk.jpg',
        },
        nl: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745718687938/app-uk.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745718687938/app-uk.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745719262201/l-uk.jpg',
        },
        uk: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745718687938/app-uk.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745718687938/app-uk.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745719262201/l-uk.jpg',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745718687567/app-de.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745718687567/app-de.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745719261672/l-de.jpg',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745718688291/app-fr.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745718688291/app-fr.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745719262442/l-fr.jpg',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745718688110/app-es.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745718688110/app-es.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745719262003/l-es.jpg',
        },
        it: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745718687728/app-it.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745718687728/app-it.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745719262688/l-it.jpg',
        },
        au: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1755502791058/3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1755502791058/3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1755502790953/3-h5.jpg',
        },
    };
    let itemsA: EcoSectionCarouselItemProps[] = [
        {
            icon: '',
            title: t('item1_title'),
            desc: t.rich('item1_desc', {
                sup: (v: string) => <sup>{v}</sup>,
            }),
            isLink: true,
            link: locale === 'jp' ? '#wave3-D' : '#wave3-D-title',
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745225463558/1.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744340439491/1.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745225463558/1.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744340439491/1.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745225461261/1-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744340439330/1-h5.jpg',
            dataLayer: {
                event: 'uaEvent',
                event_name: 'click_anchor',
                position: IS_JP_SITE ? s('Animation1.screen1.title') : s('Animation1.title'),
                button_name: t('item1_title'),
            },
        },
        {
            icon: '',
            title: t('item2_title'),
            desc: t.rich('item2_desc', {
                sup: (v: string) => <sup>{v}</sup>,
            }),
            isLink: true,
            link: IS_JP_SITE || IS_EU_SITE ? '#SectionB' : '#screen3',
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745225461885/2.jpg'
                : locale === 'us'
                ? 'https://websiteoss.ecoflow.com/upload/image/1744340440936/2.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744355044572/2-ss.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745225461885/2.jpg'
                : locale === 'us'
                ? 'https://websiteoss.ecoflow.com/upload/image/1744340440936/2.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744355044572/2-ss.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745225462223/2-h5.jpg'
                : locale === 'us'
                ? 'https://websiteoss.ecoflow.com/upload/image/1744340441506/2-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744700915815/2-ss.jpg',
            dataLayer: {
                event: 'uaEvent',
                event_name: 'click_anchor',
                position: IS_EU_SITE || IS_JP_SITE ? s('SectionB.title') : s('Animation1.screen3'),
                button_name: t('item2_title'),
            },
        },
        {
            icon: '',
            title: t('item3_title'),
            desc: t('item3_desc'),
            isLink: true,
            link: locale === 'jp' ? '#FaqA' : '#BlackA',
            ...getImgUrl(item3Img),
            dataLayer: {
                event: 'uaEvent',
                event_name: 'click_anchor',
                position: IS_JP_SITE ? s('I_title') : s('G_subTitle'),
                button_name: t('item3_title'),
            },
        },
        {
            icon: '',
            title: t('item4_title'),
            desc: t.rich('item4_desc', {
                sup: (v: string) => <sup>{v}</sup>,
            }),
            isLink: true,
            link: locale === 'jp' ? '#BlackA' : '#FaqA',
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745225462475/4.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744340439684/5.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745225462475/4.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744340439684/5.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745225462655/4-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744340439879/5-h5.jpg',
            dataLayer: {
                event: 'uaEvent',
                event_name: 'click_anchor',
                position: IS_JP_SITE ? s('G_subTitle') : s('I_title'),
                button_name: t('item4_title'),
            },
        },
        {
            icon: '',
            title: t('item5_title'),
            desc: t('item5_desc'),
            isLink: true,
            link: '#SectionD',
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745225462255/5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744340440514/3.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745225462255/5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744340440514/3.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745225461424/5-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744340440729/3-h5.jpg',
            dataLayer: {
                event: 'uaEvent',
                event_name: 'click_anchor',
                position: s('K_title'),
                button_name: t('item5_title'),
            },
        },
    ];

    if (locale === 'au') {
        itemsA = [
            {
                icon: '',
                title: t('item1_title'),
                desc: t.rich('item1_desc', {
                    sup: (v: string) => <sup>{v}</sup>,
                }),
                isLink: true,
                link: '#wave3-D',

                pc: 'https://websiteoss.ecoflow.com/upload/image/1744355044572/2-ss.jpg',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1744355044572/2-ss.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1744700915815/2-ss.jpg',
                dataLayer: {
                    event: 'uaEvent',
                    event_name: 'click_anchor',
                    position: IS_JP_SITE ? s('Animation1.screen1.title') : s('Animation1.title'),
                    button_name: t('item1_title'),
                },
            },
            {
                icon: '',
                title: t('item2_title'),
                desc: t.rich('item2_desc', {
                    sup: (v: string) => <sup>{v}</sup>,
                }),
                isLink: true,
                link: '#SectionB',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1744340439491/1.jpg',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1744340439491/1.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1744340439330/1-h5.jpg',
                dataLayer: {
                    event: 'uaEvent',
                    event_name: 'click_anchor',
                    position: IS_EU_SITE || IS_JP_SITE ? s('SectionB.title') : s('Animation1.screen3'),
                    button_name: t('item2_title'),
                },
            },
            {
                icon: '',
                title: t('item3_title'),
                desc: t('item3_desc'),
                isLink: true,
                link: locale === 'jp' ? '#FaqA' : '#BlackA',
                ...getImgUrl(item3Img),
                dataLayer: {
                    event: 'uaEvent',
                    event_name: 'click_anchor',
                    position: IS_JP_SITE ? s('I_title') : s('G_subTitle'),
                    button_name: t('item3_title'),
                },
            },
            {
                icon: '',
                title: t('item4_title'),
                desc: t.rich('item4_desc', {
                    sup: (v: string) => <sup>{v}</sup>,
                }),
                isLink: true,
                link: locale === 'jp' ? '#BlackA' : '#FaqA',
                pc: IS_JP_SITE
                    ? 'https://websiteoss.ecoflow.com/upload/image/1745225462475/4.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1744340439684/5.jpg',
                pad: IS_JP_SITE
                    ? 'https://websiteoss.ecoflow.com/upload/image/1745225462475/4.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1744340439684/5.jpg',
                h5: IS_JP_SITE
                    ? 'https://websiteoss.ecoflow.com/upload/image/1745225462655/4-h5.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1744340439879/5-h5.jpg',
                dataLayer: {
                    event: 'uaEvent',
                    event_name: 'click_anchor',
                    position: IS_JP_SITE ? s('G_subTitle') : s('I_title'),
                    button_name: t('item4_title'),
                },
            },
            {
                icon: '',
                title: t('item5_title'),
                desc: t('item5_desc'),
                isLink: true,
                link: '#SectionD',
                pc: IS_JP_SITE
                    ? 'https://websiteoss.ecoflow.com/upload/image/1745225462255/5.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1744340440514/3.jpg',
                pad: IS_JP_SITE
                    ? 'https://websiteoss.ecoflow.com/upload/image/1745225462255/5.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1744340440514/3.jpg',
                h5: IS_JP_SITE
                    ? 'https://websiteoss.ecoflow.com/upload/image/1745225461424/5-h5.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1744340440729/3-h5.jpg',
                dataLayer: {
                    event: 'uaEvent',
                    event_name: 'click_anchor',
                    position: s('K_title'),
                    button_name: t('item5_title'),
                },
            },
        ];
    }
    return (
        <div className={styles.comp} id="ListA1">
            {locale !== 'au' && <EcoSpace />}
            <EcoSectionCarousel
                headerLayout="header-top"
                pagination
                title={t('title')}
                items={itemsA}
                swiperAutoPlay
                theme="white"
                autoplay={{
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                    animationNavigationRight: true,
                    viewport: {
                        open: true,
                    },
                }}
            />
            {(pageStatus === 'statusB' || locale === 'jp') && <EcoSpace />}
        </div>
    );
}
